import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Typography,
} from "@mui/material";
import { MdClose } from "react-icons/md";
import { ValidatorForm } from "react-material-ui-form-validator";
import Box from "@mui/material/Box";
import successimage from "../../../assets/images/sucessImge.png";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import classes from "./location.module.css";
import moment from "moment";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import { LOCATION } from "../../../api-calls/api-urls";
import { saveLocationList } from "../../../Redux/actions/location-action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getLanguagedataFunction } from "../../../utilities/language";
import {
  TimePickerIcon,
} from "../../../components/Icons";
import AlertBox from "../../../components/AlertBox";

const AssignLaterModel = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [modalToggle, setModalToggle] = useState(true);
  const rootRef = React.useRef(null);
  const [update, setUpdate] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState("");
  const [date, setDate] = React.useState();
  const [time, setTime] = useState();
  const [success, setSuccess] = useState(false);
  const ln = useSelector((state) => state.allUsers.language_json);

  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!ln]);

  useEffect(() => {
    if (props.success) {
      setSuccess(true);
    }
  }, [props.success]);

  // eslint-disable-next-line unused-imports/no-unused-vars
  function closeModal(message) {
    setModalToggle(false);
    if (success) {
      navigate("/location");
      props.closeModal(false, true);
      getLocationData();
    } else {
      props.closeModal(false, false);
    }
  }

  // eslint-disable-next-line unused-imports/no-unused-vars
  const getAvailableTimes = () => {
    const selectedDate = moment(new Date(date)).format("YYYY-MM-DD");
    const currentDateTime = moment(new Date()).format("YYYY-MM-DD");

    if (selectedDate === currentDateTime) {
      console.log("get oin this");
      const currentHour = new Date().getHours();
      const currentMinute = new Date().getMinutes();

      // Create an array of time options for the next 24 hours
      const timeOptions = [];
      for (let hour = currentHour; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 15) {
          // Exclude past times
          if (
            hour > currentHour ||
            (hour === currentHour && minute >= currentMinute)
          ) {
            const time = new Date();
            time.setHours(hour);
            time.setMinutes(minute);
            timeOptions.push(time);
          }
        }
      }

      return timeOptions;
    } else {
      return [];
    }
  };

  useEffect(() => {
    if (window.location.pathname.includes("update")) {
      setUpdate(true);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.pathname]);

  const getLocationData = async () => {
  try {
    const userEntry = {};
    const { data } = await authApi.post(LOCATION, userEntry, {
      headers: { Authorization: getAuthorizationHeader() },
    });
    dispatch(saveLocationList(data));
    navigate("/location");
  } catch (error) {
    console.log(error);
  }
  };

  const handleSubmit = async () => {
    if (date && time) {
      const isoDate = moment(date).format("YYYY-MM-DD");
      const isoTime = moment(time.$d).format("HH:mm:ss");
      const assigntime = new Date(isoDate + " " + isoTime);
      // console.log("isoDate", assigntime);
      // const isoDateTime = `${isoDate}T${isoTime}`;
      // const originalMoment = moment(isoDateTime);
      // console.log(originalMoment);
      // const modifiedIsoDateTime = originalMoment.format("YYYY-MM-DDTHH:mm:ss");
      // console.log(modifiedIsoDateTime);
      let UserEntry = props.UserEntry;
      UserEntry.assigned_on = new Date(assigntime);
      console.log(UserEntry);
      const isFuture = moment(assigntime).isAfter();
      if (isFuture) {
        if (props.editLocation) {
          try {
            // eslint-disable-next-line unused-imports/no-unused-vars
            const { data } = await authApi.put(
              `${LOCATION}/${props.editLocation._id}`,
              UserEntry,
              {
                headers: { Authorization: getAuthorizationHeader() },
              }
            );
          } catch (error) {
            console.log(error);
            setShowAlert(true);
            setError(error.response.data.message);
            return;
          }
        } else {
          try {
            // eslint-disable-next-line unused-imports/no-unused-vars
            const { data } = await authApi.post(
              `${LOCATION}/create`,
              UserEntry,
              {
                headers: { Authorization: getAuthorizationHeader() },
              }
            );
          } catch (error) {
            console.log(error);
            setShowAlert(true);
            setError(error.response.data.message);
            return;
          }
        }
        setSuccess(true);
      } else {
        setShowAlert(true);
        setError("Please select future date and time");
      }
    }
  };
  return (
    <div>
      {ln ? (
        <Modal
          open={modalToggle}
          onClose={() => closeModal()}
          aria-labelledby="server-modal-title"
          data-testid="register_modal"
          aria-describedby="server-modal-description"
          sx={{
            display: "flex",
            height: 480,
            marginTop: 10,
            justifyContent: "center",
          }}
          container={() => rootRef.current}
        >
          <Box
            sx={{
              position: "relative",
              bgcolor: "background.paper",
              borderRadius: 1,
              boxShadow: (theme) => theme.shadows[5],
            }}
            style={{
              width: "max-content",
              minWidth: "460px",
              height: "fit-content",
            }}
            className={classes.loginModalWidth}
          >
            <Button
              variant="text"
              sx={{ minWidth: "unset" }}
              className={classes.closebtn}
              onClick={() => closeModal()}
            >
              <MdClose />
            </Button>
            {!success ? (
              <div>
                <div className={classes.AddMemberHeading}>
                  <Typography variant="h5" sx={{ fontWeight: 700 }}>{ln.assign_later}</Typography>
                </div>
                <ValidatorForm
                  useref="form"
                  onSubmit={handleSubmit}
                  className={classes.modalmain}
                >
                    <div className={classes.depFormContainer}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div>
                          <Typography className={classes.form_lable}>
                            {ln.date}
                          </Typography>
                          <Box sx={{ mt: "10px" }}>
                            <DatePicker
                              sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                width: "100%",
                              }}
                              slotProps={{ textField: { size: "small" } }}
                              value={date ? dayjs(date) : null}
                              minDate={dayjs()}
                              onChange={(newDate) =>
                                setDate(newDate ? newDate.toDate() : null)
                              }
                            />
                          </Box>
                        </div>
                        <div>
                          <Typography className={classes.form_lable}>
                            {ln.time}
                          </Typography>
                          <div
                            className={classes.timePickerContainer}
                            style={{ width: "100%", marginTop: "10px" }}
                          >
                            <MobileTimePicker
                              sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                width: "100%",
                                cursor: "pointer",
                              }}
                              value={time}
                              className={classes.timePicker}
                              onChange={(newValue) => setTime(newValue)}
                            />
                            <span
                              className={classes.datePickerCalendarIcon}
                              style={{ right: "10px" }}
                            >
                              <TimePickerIcon />
                            </span>
                          </div>
                        </div>
                      </LocalizationProvider>
                      <div className={classes.addMemberModalbtnSection}>
                      <Button
                        variant="outlined"
                        style={{
                          border: "2px solid #1976d2",
                          color: "#1976d2",
                        }}
                        onClick={() => closeModal()}
                      >
                        {ln.cancel}
                      </Button>
                      <Button variant="contained" type="submit">
                        Assign
                      </Button>
                    </div>
                  </div>
                </ValidatorForm>
              </div>
            ) : (
              <div className={classes.addMembersuccess}>
                <img
                  src={successimage}
                  alt="success"
                  width="auto"
                  height="auto"
                />
                <Typography className={classes.imagePageText1}>
                  {update
                    ? "Task Updated SuccessFully"
                    : props.repeatSuccessMessage
                      ? "Repeating Task Set Up"
                      : "Task Assigned"}
                </Typography>
                <Typography className={classes.successPageSubText}>
                  Task has been assigned to <b>{props.teamMemberName}</b>{" "}
                  for <b>{props.title}</b>{" "}
                  {!props.success &&
                    `on ${moment(date).format("DD[th] MMM YYYY")}`}
                </Typography>
                {props.repeatSuccessMessage && (
                  <Typography className={classes.successPageSubText}>
                    {props.repeatSuccessMessage}
                  </Typography>
                )}
              </div>
            )}
          </Box>
        </Modal>
      ) : null}
      {showAlert && error && (
        <AlertBox type="error" message={error} stateName={setShowAlert} />
      )}
    </div>
  );
};

export default AssignLaterModel;
